__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@apps/user";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.4", function() { return __webpack_require__.e(450).then(function() { return function() { return __webpack_require__(7450); }; }); });
			register("@emotion/styled", "11.10.4", function() { return Promise.all([__webpack_require__.e(245), __webpack_require__.e(206)]).then(function() { return function() { return __webpack_require__(5245); }; }); });
			register("@mui/icons-material", "5.10.3", function() { return Promise.all([__webpack_require__.e(223), __webpack_require__.e(486), __webpack_require__.e(206), __webpack_require__.e(718), __webpack_require__.e(664)]).then(function() { return function() { return __webpack_require__(8486); }; }); });
			register("@mui/material", "5.13.6", function() { return Promise.all([__webpack_require__.e(223), __webpack_require__.e(453), __webpack_require__.e(218), __webpack_require__.e(206), __webpack_require__.e(718), __webpack_require__.e(563), __webpack_require__.e(141)]).then(function() { return function() { return __webpack_require__(8218); }; }); });
			register("dayjs", "1.11.10", function() { return __webpack_require__.e(892).then(function() { return function() { return __webpack_require__(7892); }; }); });
			register("formik", "2.2.9", function() { return __webpack_require__.e(705).then(function() { return function() { return __webpack_require__(5705); }; }); });
			register("moment", "2.29.4", function() { return __webpack_require__.e(426).then(function() { return function() { return __webpack_require__(2426); }; }); });
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(4164); }; }, 1);
			register("react-i18next", "11.18.6", function() { return __webpack_require__.e(691).then(function() { return function() { return __webpack_require__(2691); }; }); });
			register("react-lazily", "0.9.1", function() { return __webpack_require__.e(548).then(function() { return function() { return __webpack_require__(3548); }; }); });
			register("react-query", "3.39.2", function() { return Promise.all([__webpack_require__.e(933), __webpack_require__.e(563)]).then(function() { return function() { return __webpack_require__(1933); }; }); });
			register("react-router-dom", "6.3.0", function() { return Promise.all([__webpack_require__.e(608), __webpack_require__.e(439)]).then(function() { return function() { return __webpack_require__(608); }; }); });
			register("react", "17.0.2", function() { return function() { return __webpack_require__(2791); }; }, 1);
			initExternal(5631);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};